// extracted by mini-css-extract-plugin
module.exports = {"title":"Title-module--title--16rrq","loc":"Title-module--loc--1iF-a","optional":"Title-module--optional--eykfy"};